import Navbar from '../../components/navbar/navbar';
import useSetSiteLanguage from '../../hooks/useSetSiteLanguage';
import ContentBlock from './../../components/contentBlock/contentBlock'
import './aboutUsPageStyle.css'
import H2Title from '../../components/text/h2Title/h2Title';
import Footer from './../../components/footer/footer'


export default function AboutUs() {
    const siteContent = useSetSiteLanguage();

    return (
        <>
            <Navbar data={siteContent?.navbar} />
            <div className='about-us-page__container'>
                <H2Title title={siteContent?.aboutUsPage?.summary?.title} color={"white"}/>
                
                <ContentBlock
                    text={siteContent?.aboutUsPage?.summary?.text}
                    photo={siteContent?.aboutUsPage?.summary?.photo}
                />

                <div className='about-us-page__content-wrapper'>
                    {siteContent?.aboutUsPage?.detailed.map( (item, index) => (
                        <ContentBlock
                            title={item.title}
                            photo={item.photo}
                            text={item.text}
                            type={item.type}
                            key={index}/>
                    ))}
                </div> 
            </div>
            <Footer  
                email={siteContent?.contactSection?.email}
                linkedin={siteContent?.contactSection?.linkedin}
                whatsapp={siteContent?.contactSection?.whatsapp}/>
        </>
    );
}
